var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBusStop = function SvgBusStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#FFF",
    strokeWidth: 0.909,
    d: "M10 .455c2.638 0 5.027 1.029 6.756 2.695 1.722 1.66 2.79 3.954 2.79 6.488 0 5.567-5.537 10.54-8.647 13.38-.438.4-.661.528-.899.527a.82.82 0 0 1-.556-.214l-.403-.37C5.865 20.06.455 15.195.455 9.639c0-2.534 1.067-4.827 2.79-6.488C4.972 1.484 7.361.455 10 .455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.234 7.298c-.084-1.017-.254-1.863-.595-2.202-1.107-1.27-8.851-1.355-9.702 0-.255.338-.425 1.185-.511 2.202-.34 0-.596.338-.596.677v1.27c0 .255.17.509.426.593 0 2.033 0 4.065.085 5.166 0 .762.596.593.596.593h.51v.931c0 .34.34.593.767.593.425 0 .766-.254.766-.593v-.931h5.957v.931c0 .34.34.593.766.593.425 0 .85-.254.85-.593v-.931h.086s.681.084.681-.254c0-1.017.085-3.303.085-5.505a.637.637 0 0 0 .425-.592v-1.27c0-.34-.255-.678-.596-.678zM6.81 5.35h5.957v.847H6.81V5.35zm.085 9.231a.851.851 0 0 1-.85-.847c0-.423.425-.847.85-.847a.85.85 0 0 1 .851.847c0 .508-.34.847-.85.847zm5.872 0c-.51 0-.85-.339-.85-.847a.85.85 0 0 1 .85-.847c.426 0 .851.424.851.847a.85.85 0 0 1-.85.847zm1.022-3.641h-8V6.705h8v4.235z"
  }))));
};
export default SvgBusStop;